import EmailSection from "./EmailSection";
import { formatNumberWithCommas, unformatNumber } from "./helpers";

const PropertyDetails = ({
  handleChange,
  formData,
  setFormData,
  resetHandler,
  userParams, 
  setUserParams,
}) => {

    // Commas to thousands
    const handlePurchasePriceChange = (e) => {
      const rawValue = unformatNumber(e.target.value);
      if (!isNaN(rawValue)) {
        setFormData({
          ...formData,
          purchasePrice: rawValue
        });
      }
    };
    const handleBayerAttorneyFeeChange = (e) => {
      const rawValue = unformatNumber(e.target.value);
      if (!isNaN(rawValue)) {
        setFormData({
          ...formData,
          bayerAttorneyFee: rawValue,
        });
      }
    };

    const otherAmmountChange = (e) => {
      const rawValue = unformatNumber(e.target.value);
      if (!isNaN(rawValue)) {
        setFormData({
          ...formData,
          amountFinancedDollar: rawValue,
        });
      }
    };

    return(
        <div id='left' className="col-12 col-md-10 col-lg-6">
            <h4>Buyer Closing Cost Calculator</h4>
            <div class="mb-3">
              <label for="sale_price" class="form-label">Purchase Price</label>
              <div className="input-wrapper">
                <input  id="sale_price" class="form-control form-control-lg"
                  type="text"
                  name="purchasePrice"
                  value={formatNumberWithCommas(formData.purchasePrice)}
                  onChange={handlePurchasePriceChange}
                />
              </div>
            </div>
            <div class="mb-3">
              <label for="sale_price" class="form-label">Property type</label>
              <select class="form-select form-select-lg" 
                name="propertyType"
                value={formData.propertyType}
                onChange={handleChange}
              >
                <option value="1">Condo</option>
                <option value="2">Coop</option>
                <option value="3">House</option>
              </select>
            </div>
            <div class="mb-3-">
              <label for="sale_price" class="form-label">Amount Financed</label>
              {/* SELECT HERE */}
            </div>
            <div class="row mb-3 flip-tax">
              <div class="col col-md-6 col-lg-6">
                <select class="form-select form-select-lg" 
                  name="amountFinancedPrecent"
                  value={formData.amountFinancedPrecent}
                  onChange={handleChange}
                >
                  <option value="0.7">70%</option>
                  <option value="0.75">75%</option>
                  <option value="0.8">80%</option>
                  <option value="0.9">90%</option>
                  <option value="1">All Cash</option>
                  <option value="0">Other</option>
                </select>
              </div>
              {
                formData.amountFinancedPrecent === '0' &&
                <div class="col col-md-6 col-lg-6">
                  <div className="input-wrapper">
                    <input type="text" id="flip_tax" class="form-control form-control-lg"
                      name="amountFinancedDollar"
                      value={formatNumberWithCommas(formData.amountFinancedDollar)}
                      onChange={otherAmmountChange}
                    />
                  </div>
                </div>
              }
            </div>
            
            <div class="row mb-3">
              <div class="col-md-6 col-12">
                  <label for="attorney_fee" class="form-label">Buyer's Attorney Fee</label>
                  <div className="input-wrapper">
                    <input type="text" id="attorney_fee" class="form-control form-control-lg" 
                      name="bayerAttorneyFee"
                      value={formatNumberWithCommas(formData.bayerAttorneyFee)}
                      onChange={handleBayerAttorneyFeeChange}
                    />
                </div>
              </div>
            </div>
            
            <div class="row mb-1 flip-tax">
              <div class="col-md-6 col-12">
                <div class="form-check form-switch mb-3">
                  
                  <div className="right-place">
                    <input class="form-check-input" type="checkbox" role="switch" id="exstng_mortgage"
                      name="newConstruction"
                      checked={formData.newConstruction}
                      onChange={handleChange}
                    />
                    {/* <label for="exstng_mortgage" class="form-label">NO/YES</label> */}
                  </div>
                  <label class="form-check-label left-place" for="exstng_mortgage">New Construction</label>
                </div>
              </div>
            </div>
            <span id="desktopEmail">
              <EmailSection 
                formData={formData}
                setFormData={setFormData}
                resetHandler={resetHandler}
                userParams={userParams} 
                setUserParams={setUserParams}
              />
            </span>

          </div>
    );
}

export default PropertyDetails;